import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/** `cellRendererParams` of the thumbnail column. */
export interface AgThumbnailCellRendererParams {
  /** Resolves the row to an image URL; return null/undefined for no thumbnail. */
  url: (data: any) => string | null | undefined;
  /** Optional accessible name; defaults to an empty alt (decorative preview). */
  alt?: string | ((data: any) => string);
}

/**
 * Preview image column: the thumbnail, wrapped in a link that opens the full
 * image in a new tab. Replaces the raw `<a><img style=...></a>` HTML strings
 * grids used to build inline - the chrome lives in the stylesheet on tokens.
 */
@Component({
  selector: 'app-ag-thumbnail-cell-renderer',
  templateUrl: './ag-thumbnail-cell-renderer.component.html',
  styleUrl: './ag-thumbnail-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgThumbnailCellRendererComponent implements ICellRendererAngularComp {
  url: string | null = null;
  alt = '';

  agInit(params: ICellRendererParams & AgThumbnailCellRendererParams): void {
    this.setParams(params);
  }

  refresh(
    params: ICellRendererParams & AgThumbnailCellRendererParams,
  ): boolean {
    this.setParams(params);
    return true;
  }

  private setParams(
    params: ICellRendererParams & AgThumbnailCellRendererParams,
  ): void {
    this.url = params.data ? (params.url(params.data) ?? null) : null;
    this.alt =
      typeof params.alt === 'function'
        ? params.alt(params.data)
        : (params.alt ?? '');
  }
}
